export enum EnumPartnerReason {
  ACQUISITION_OF_NEW_CUSTOMERS = "Produtos da Caju para aquisição de novos clientes",
  CUSTOMERS_BASE = "Produtos da Caju para minha base de clientes",
  PROTECT_CUSTOMERS_BASE = "Produtos da Caju para proteger minha carteira de clientes",
  CUSTOMER_REQUESTED = "Cliente solicitou pelo produto da Caju",
  ANOTHER_MOTIVE = "Outro motivo",
}
